import { Provider } from '@angular/core';
import { AuthProvider } from '../../features/auth/api/providers/auth';
import { ConfigProvider } from './config';
import { UserProvider } from '../../features/users/api/providers/user';
import { ProducerProvider } from '../../features/producer/api/providers/producer';
import { CampaignProvider } from '../../features/campaign/api/providers/campaign';
import { CampaignItemProvider } from '../../features/campaign/api/providers/campaignitem';
import { UploadProvider } from '../../features/campaign/api/providers/upload';
import { CampaignItemFileProvider } from '../../features/campaign/api/providers/campaignitemfile';

// Add other providers here (e.g., services, interceptors, etc.)
export const CORE_PROVIDERS: Provider[] = [ConfigProvider, ProducerProvider];

export const PAGE_PROVIDERS: Provider[] = 
[   AuthProvider,
    UserProvider, 
    CampaignProvider, 
    CampaignItemProvider, 
    UploadProvider,
    CampaignItemFileProvider
];

